import { Box, styled } from "@mui/material";
import React from "react";

const WsPhantomNav = () => {
  return <WsPhantomNavContainer></WsPhantomNavContainer>;
};

export default WsPhantomNav;

const WsPhantomNavContainer = styled(Box)`
  width: 100%;
  height: 70px;
`;
